import React from 'react'
import styles from './FriendRequestsList.scss'
import { Card } from 'common/styleguide/Card'
import { ProfileImg } from 'common/ProfileImg'
import { urls } from 'lib/urls'
import { Msg, commonVerbs } from 'lib/localization'
import PropTypes from 'prop-types'
import { FormattedMessage as T } from 'react-intl'

export class FriendRequestsList extends React.PureComponent {
  static propTypes = {
    onConfirmClicked: PropTypes.func.isRequired,
    onIgnoreClicked: PropTypes.func.isRequired,
    onUnfriendClicked: PropTypes.func.isRequired
  }

  render () {
    const {
      pendingIncomingFriends,
      pendingOutgoingFriends,
      onConfirmClicked,
      onIgnoreClicked,
      onUnfriendClicked
    } = this.props
    return (
      <div>
        <h2 data-heading-alt><T id='friendRequestsList.pending' defaultMessage='Pending Friends' /></h2>
        <Card className={styles.pendingFriendsCard}>
          {!pendingIncomingFriends.isEmpty() && pendingIncomingFriends.toIndexedSeq().map((user) => {
            return <div key={user.id} className={styles.request}>
              <a href={urls.users.show(user.id)}>
                <ProfileImg user={user} />
              </a>
              <div className={styles.user}>
                <div className={styles.name}>{user.name}</div>
                <div className={styles.buttons}>
                  <a onClick={() => onConfirmClicked(user.id)}><Msg capitalized m={commonVerbs.accept} /></a>
                  <a onClick={() => onIgnoreClicked(user.id)} className={styles.right}><Msg capitalized m={commonVerbs.ignore} /></a>
                </div>
              </div>
            </div>
          })}

          {!pendingOutgoingFriends.isEmpty() && pendingOutgoingFriends.toIndexedSeq().map((user) => {
            return <div key={user.id} className={styles.request}>
              <a href={urls.users.show(user.id)}>
                <ProfileImg user={user} />
              </a>
              <div className={styles.user}>
                <div className={styles.name}>{user.name}</div>
                <div className={styles.buttons}>
                  <a onClick={() => onUnfriendClicked(user.id)}><Msg capitalized m={commonVerbs.remove} /></a>
                </div>
              </div>
            </div>
          })}
        </Card>
      </div>
    )
  }
}
